export default __webpack_public_path__ + "static/media/a019-4.2682093b.svg";